module.exports = __webpack_public_path__ + "img/BMS&EMS系统_02.f829e272.png";